const appSubPath = (path: string) => {
  if (
    process.env.REACT_APP_SUB_PATH !== ''
    && process.env.REACT_APP_SUB_PATH !== undefined
  ) {
    return process.env.REACT_APP_SUB_PATH + path;
  }
  return path;
};

export default appSubPath;

/**
 * to capitalize characters of the string
 * @param string string to format
 * @param capitalizeCharacter how characters will capitalize
 * @returns `string`
 */
export const toCapitalize = (string: string, capitalizeCharacter: 'first' | 'all' = 'first') => {
  if (capitalizeCharacter === 'all') {
    return string.toUpperCase();
  }
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
};